// extracted by mini-css-extract-plugin
export default {"greyLink":"App_greyLink__DClAw"};